<script>
    import { scroll } from './state';

    const mobileBreakpoint = 900;
    let width = 700;
    let scrollIndex = 0;

    const unsubscribeScroll = scroll.subscribe(({ index }) => {
        scrollIndex = index;
    })
    
</script>

<style>
</style>

<svelte:window bind:innerWidth={width}/>
